import { React, useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import Button from "../../../components/cofButton/Button";
import { useDispatch, useSelector } from "react-redux";
import { resetPassword } from "../../../actions/resetPasswordActions";
import CustomInput from "../../../components/customInput/CustomInput";
import { useTranslation } from "react-i18next";

const ResetPasswordScreen = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const { t } = useTranslation();

  // Redux stanje za resetovanje lozinke
  const resetPasswordState = useSelector((state) => state.resetPassword);
  const { loading, success, error } = resetPasswordState;

  const handleSignIn = (e) => {
    e.preventDefault();
    dispatch(resetPassword(email));
  };

  return (
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ paddingTop: "100px" }}
    >
      <Row>
        <Col
          xs={12}
          className="d-flex align-items-center justify-content-center"
        >
          <h2>{t("resetPassword.title")}</h2>
        </Col>
        <Col xs={12}>
          <p>{t("resetPassword.instructions")}</p>
        </Col>

        <Col xs={12}>
          <Form>
            <Form.Group style={{ marginBottom: "10px" }}>
              <CustomInput
                type="text"
                placeholder={t("resetPassword.emailPlaceholder")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>
            <Button className="w-100 rounded-0 border-0" onClick={handleSignIn}>
              {t("resetPassword.submitButton")}
            </Button>
          </Form>
        </Col>

        {/* Prikazivanje poruka kada je email poslat */}
        <Col xs={12} className="text-center mt-3">
          {loading && <p>{t("resetPassword.loadingMessage")}</p>}
          {success && (
            <p style={{ color: "green" }}>
              {t("resetPassword.successMessage")}
            </p>
          )}
          {error && (
            <p style={{ color: "red" }}>
              {t("resetPassword.errorMessage")}
            </p>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default ResetPasswordScreen;
